import { Divider, List, ListItem, ListSubheader, Stack, Typography } from "@mui/material";
import { twMerge } from "tailwind-merge";

// Interfaces
import { IGroupedOptionsProps, ISpecificGroupingProperties, IGeneralParamsProps } from "../interfaces";

const getLabel = (group = "", callbackFn: Function | undefined = undefined): string => {
	if (!callbackFn) {
		return group;
	}
	return callbackFn?.(group);
};

const getProperties = (group = "", properties: ISpecificGroupingProperties | undefined = undefined): IGeneralParamsProps | null => {
	if (!properties) {
		return null;
	}
	return properties[group] ?? properties["*"] ?? null;
};

const GroupLabel = (props: Readonly<IGroupedOptionsProps>) => {
	const { group = "", groupingProps = undefined } = props;
	const { classes = "", defaultLabel = "", specificProperties = undefined, groupLabel = undefined } = groupingProps || {};
	const properties = getProperties(group, specificProperties);
	const { classes: particularClasses = "", icon = null, sx = null } = properties ?? {};

	const label = getLabel(group || defaultLabel, groupLabel);

	return (
		<Stack px={"10px"}>
			<Stack direction={"row"} alignItems={"center"} spacing={1}>
				<Typography
					noWrap
					className={twMerge("!font-montserrat !font-[500] !text-[14.5px] !text-disabled", classes, particularClasses)}
					sx={{ fontVariant: "small-caps", ...sx }}
				>
					{label}
				</Typography>
				{icon}
			</Stack>
		</Stack>
	);
};

export default function RenderGroup(props: Readonly<IGroupedOptionsProps>) {
	const { index = 0, children = null, groupingProps = undefined } = props;
	const { sticky = false, divider = false } = groupingProps || {};
	const isFirstGroup = !index;

	// Sticky definition
	const isSticky = Boolean(groupingProps) && sticky;

	return (
		<ListItem sx={{ padding: 0, paddingTop: !isFirstGroup ? "10px" : 0, display: "block" }}>
			<List disablePadding>
				{isSticky ? (
					<ListSubheader disableGutters sx={{ padding: "4px 0", top: "-9px" }}>
						<GroupLabel {...props} />
					</ListSubheader>
				) : (
					<GroupLabel {...props} />
				)}

				{children}
			</List>
			{divider && <Divider className="!border-disabled !mx-[10px] pt-[10px] " />}
		</ListItem>
	);
}
